import React from 'react';
import {DivRodape,DivRodapeInformacoes,DivInternaInformacoes,} from './styleIndexPreview';
import {IconInstagram,IconFacebook,IconTwitter,IconYoutube} from './styleIndexPreview';
import {Button} from '../postEdit/stylePostEdit';

export default function RodapePreview(){
    let logo = JSON.parse(localStorage.getItem('currentUser'));


    return(<>
    <DivRodapeInformacoes style={{marginBottom:'20px'}}>
            <DivInternaInformacoes>
                <DivRodape>
                    <h2>INFORMAÇÕES SOBRE CONSULTAS</h2>
                    <p>Local de Atendimento:</p>
                    <p><strong>Icaraí:</strong>Rua Tavares de Macedo, 95. Salas 805 e 806. Centro empresarial Chicago.</p>
                    <p><strong>Barra:</strong>Av. Embaixador Abelardo Bueno 1, Edifício Ayrton Senna 2, Sala 522 – Dimmension Office Park.</p>
                    <Button>(21)99145-2150</Button>
                </DivRodape>
                <DivRodape>
                    <h2>FIQUE POR DENTRO</h2>
                    <p>Quer receber informações sobre emagrecimento e performance física?</p>
                    <p>Cadastre-se na minha newsletter!</p>
                    <p>Pode ficar tranquilo(a) que não vou encher sua caixa de entrada.</p>
                    <Button>QUERO RECEBER INFORMAÇÕES</Button>
                </DivRodape>
                <DivRodape>
                    <h2>SIGA ME</h2>
                    <p>Acompanhe-me nas minhas redes sociais:</p>
                    <div>
                       <a href={logo.Instagram}><IconInstagram /></a>
                       <a href={logo.Facebook}><IconFacebook /></a>
                       <a href='#'><IconTwitter /></a>
                       <a href={logo.Youtube}><IconYoutube /></a>
                    </div>
                </DivRodape>
            </DivInternaInformacoes>
        </DivRodapeInformacoes>
    </>)
}
